import React, {Fragment} from 'react';
import RcDrawer from 'rc-drawer';

const Drawer = props => {
  const {
    className,
    children,
    closeButton,
    drawerHandler,
    toggleHandler,
    open,
    width,
    placement,
    drawerClassName,
    closeButtonContainerClassName,
    ...rest
  } = Object.assign({}, {open: false}, props);

  return (
    <Fragment>
      <RcDrawer
        open={open}
        onClose={toggleHandler}
        className={`drawer ${className ? className : ''}`.trim()}
        width={width}
        placement={placement}
        handler={false}
        level={null}
        duration="0.4s"
        {...rest}>
        {closeButton && (
          <div onClick={toggleHandler} className={closeButtonContainerClassName}>
            {closeButton}
          </div>
        )}
        <div className={drawerClassName}>{children}</div>
      </RcDrawer>
      <div className="drawer__handler" style={{display: 'inline-block'}} onClick={toggleHandler}>
        {drawerHandler}
      </div>
    </Fragment>
  );
};

export default Drawer;
